import { NODE_ENV } from '@/defines/env'
import { Errors } from '@/defines/errors'
import { DialogAlert } from '@/utils/dialog.js'

export const catchPlugin = {
  install(Vue) {
    Vue.mixin({
      methods: {
        async $catch(error, { type = 'alert', callback = () => {} } = {}) {
          let content = '运行错误，请联系客服处理'
          switch (error.type) {
            case Errors.AJAX.NETWORK_ERROR:
              content = `网络错误，请稍后重试(${error.response.status})`
              break
            case Errors.AJAX.RESPONSE_ERROR:
              content = error.res.error?.msg || error.res.message
              break
            case Errors.AUTH.NOT_LOGIN:
              content = '您尚未登录，请登录后再试'
              break
          }
          if (type === 'alert') {
            try {
              await DialogAlert(content)
              callback()
            } catch (error) {}
          }
          if (type === 'toast') {
            this.$toast(content)
          }
          NODE_ENV === 'development' && console.warn(error)
        }
      }
    })
  }
}
